import { AssetIcon } from 'assets/icons/AssetIcon';
import cx from 'classnames';
import Typography, { TypographyColor } from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import { I18nNamespace } from 'constants/i18n.const';
import { LOGGING_LEVEL } from 'constants/logging.const';
import { SelfeRouteConst } from 'constants/route.const';
import { useAppContext } from 'context/AppContext';
import { emitSeqLog } from 'functions/seq-logging.func';
import { formatMoneyVN } from 'helpers/math.helper';
import { isEqualVal } from 'helpers/string.helper';
import { useModal } from 'hooks/useModal';
import { useTranslation } from 'hooks/useTranslation';
import React, { useMemo, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { store } from 'store';
import './offline-popup.css';

function OfflinePopup() {
  const { T } = useTranslation([I18nNamespace.COMMON, I18nNamespace.PAGE]);
  const { openErrorModal, closeConfirmModal } = useModal();
  const { isOnline } = useAppContext();
  const { pathname } = useLocation();
  const depositRef = useRef(0);
  const navigate = useNavigate();

  const handleShowOfflineWarning = () => {
    const { depositAmount, appliedVoucherValue } =
      store.getState()?.selfeApp || {};
    depositRef.current = depositAmount - appliedVoucherValue;
    navigate(SelfeRouteConst.START_PAGE);
    emitSeqLog?.({
      level: LOGGING_LEVEL.FATAL,
      messageTemplate: `[Offline] ${T('common:noInternet')}`,
    });
    setTimeout(
      () =>
        openErrorModal(T('common:noInternet'), {
          hidePrevNext: true,
          RenderContent: () => (
            <Typography
              variant={TYPOGRAPHY_VARIANTS.BODY}
              color={TypographyColor.SECONDARY}
              firstCapCase
            >
              {T(`${I18nNamespace.COMMON}:transactionWillBeCancel`)}
              <br />
              {T(`${I18nNamespace.COMMON}:depositAmountIs`)}: <br />
              <Typography variant={TYPOGRAPHY_VARIANTS.H1} firstCapCase>
                {formatMoneyVN(
                  Math.max(depositAmount - appliedVoucherValue, 0),
                )}{' '}
                đ
              </Typography>
              <br />
              {T(`${I18nNamespace.COMMON}:pleaseContactStaff`)}
            </Typography>
          ),
        }),
      1000,
    );
  };

  const isInStartPage = useMemo(
    () => isEqualVal(pathname, SelfeRouteConst.START_PAGE),
    [pathname],
  );

  React.useEffect(() => {
    if (!isOnline) {
      handleShowOfflineWarning();
    } else {
      closeConfirmModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnline]);

  return !isOnline ? (
    <button
      type="button"
      className={cx('btn-offline', {
        'btn-offline-in-start-page': isInStartPage,
      })}
      onClick={handleShowOfflineWarning}
      aria-label="offline warning"
    >
      <AssetIcon.Warning />
    </button>
  ) : (
    <></>
  );
}

export default OfflinePopup;
